import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { CannabisIcon } from 'Images';

export const FormTitle = () => {
  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Reimbursements);

  return (
    <Stack
      direction='row'
      gap={isDesktop ? '24px' : '16px'}
      width={isDesktop ? 'fit-content' : '100%'}
      alignItems='center'
      justifyContent={isDesktop ? undefined : 'center'}
    >
      {isDesktop && (
        <Avatar
          alt=''
          src={CannabisIcon}
          sx={{ width: '40px', height: '40px' }}
        />
      )}
      <Typography
        variant='h2'
        component='h1'
        fontWeight={700}
        fontSize={isDesktop ? '24px' : '32px'}
        alignSelf={isDesktop ? undefined : 'center'}
        tabIndex={0}
        maxWidth={isDesktop ? undefined : '200px'}
        textAlign={isDesktop ? undefined : 'center'}
      >
        {dictionary.titleCannabis}
      </Typography>
    </Stack>
  );
};
